var frca = {
	"coupon-callout": {
	"coupon-code": "Code",
	"coupon-message-with-price": "Seulement {{ price }}",
	"coupon-expiry-message": "Expire le {{ Date }}.",
	"code-at-checkout": "Entrez le code lors du paiement. Ne peut être jumelé à aucun autre code promo, promotion ou rabais.",
	"cancel-icon": "Annuler",
	"info-icon": "Voir les détails",
	"check-icon": "Appliqué",
	"promo-code": "Code promo",
	"coupon-callout-popover": "Fenêtre pop-over de référence du bon de réduction"
}
};

export { frca as default };
//# sourceMappingURL=src-localization-texts-fr-ca.json.js.map
